<template>
  <div>
    <div class="goodList">
      <div class="goodItem flexContainer" v-for="data in list" :key="data.id">
        <div class="goodItemImg goodItemImg2">
          <img
            src="https://dimg04.c-ctrip.com/images//200b1e000001fwybw3517_C_750_400_Q50.jpg_.webp"
          />
          <!-- <div class="imgTip textellipsis">
          <i class="iconfont_new icon-huo"></i>星级人气榜
          </div>-->
        </div>
        <div class="flexItem2 goodItemText">
          <div class="title firstFont">
            {{data.name}}
            <i class="iconfont_new icon-xiangyou color4" @click="showModal(1,data)"></i>
          </div>
          <div class="position secordFont">{{data.position}}</div>

          <div class="flexContainer">
            <div class="flexItem1 goodItemAllTag" style="padding: 0.2rem 0 0;">
              <span class="goodItemTag" v-for="(item,key) in data.tag" :key="key">{{item.value}}</span>
            </div>
            <div class>
              <div class="flight-number">
                <dfn>¥</dfn>
                <strong>{{data.price}}</strong>
                <dfn>起</dfn>
                <i class="iconfont_new icon-down-circle-o color4" @click="showModal(2,data)"></i>
              </div>
            </div>
          </div>
          <div class="warning">{{data.warning}}</div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

export default {
  name: "goodList2",
  props: {
    list: {
      type: Array,
      default: [],
      required: false,
    },
    detailPage: {
      type: String,
      default: "",
      required: false,
    },
  },
  data() {
    return {
      
      
    };
  },
  components: {
    
  },
  activated: function () {},
  created() {},
  mounted() {},
  methods: {
    goDetail(data) {
      let that = this;
      this.$router.push({
        name: that.detailPage,
      });
    },
    showModal(key,data){
      this.$emit("showModal", key,data);
    }
  },
};
</script>

<style scoped lang="less">
@import "../../style/home.less";
</style>



// WEBPACK FOOTER //
// src/components/child-components/goodItem2.vue